import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Search } from "lucide-react";

import { usePendingApproval } from "@/hooks/products/usePendingApproval";
import Fetching from "@/components/Fetching/Fetching";

import classes from "./ProductPending.module.scss";
import ProductPendingReview from "./ProductReview/ProductPendingReview";

const ProductPending = () => {
	const { estate_parent_id, estate_id } = useSelector((state) => state.auth.filter);

	const { data, isLoading } = usePendingApproval({ estate_parent_id, estate_id });

	const [localeProducts, setLocaleProducts] = useState([]);

	useEffect(() => {
		if (data && data.products_pending) {
			setLocaleProducts(data.products_pending);
		}
	}, [data]);

	if (isLoading) return <Fetching bottomMargin={"2em"} topMargin={"2em"} />;

	if (!data || !Array.isArray(data.products_pending) || data.products_pending.length === 0) return null;

	return (
		<>
			<div className={classes.container}>
				<div className={`${classes.titleCard} ${!data?.has_permission ? classes.titleWarning : ""}`}>
					<div className={classes.iconContainer}>
						<Search className={classes.icon} />
					</div>
					<div className={classes.textContainer}>
						<h4>Revisión de productos pendientes</h4>
						{data?.has_permission && (
							<p>
								<strong>Revisa si el producto ya existe</strong> antes de crear uno nuevo para evitar duplicados.
							</p>
						)}
						{!data?.has_permission && data?.users_with_permission.length > 0 && (
							<p>
								Debes solicitar la aprobación a uno de los siguientes usuarios:{" "}
								<strong>
									{data.users_with_permission.map((user, idx) => (
										<span key={user.id}>
											{user.name}
											{idx < data.users_with_permission.length - 1 ? ", " : ""}
										</span>
									))}
								</strong>
							</p>
						)}
					</div>
				</div>
				{localeProducts &&
					localeProducts.length > 0 &&
					localeProducts.map((product, index) => {
						return <ProductPendingReview key={index} localeProducts={localeProducts} setLocaleProducts={setLocaleProducts} product={product} />;
					})}
			</div>
		</>
	);
};

export default ProductPending;
